<template>
  <div id="weeklySummary">
    <div class="table_box">
      <el-table class="table_header" :data="progressData">
        <el-table-column prop="rowTitle" label="" min-width="130"> </el-table-column>
        <el-table-column
          v-for="day in days"
          :key="day"
          :label="$t(`promotion.fundsGrowthPromotion.weeklySummary.tableHeader.${day}`)"
          min-width="150"
        >
          <template slot-scope="scope">
            <div v-if="scope.row[day] && (scope.row[day].type === 'balance' || scope.row[day].success)">
              <i :class="['el-icon-success', 'text-base', { active: scope.row[day].success }]"></i>
              <span :class="[{ 'text-blueG0': scope.row[day].success, text_default: !scope.row[day].success }]">
                ${{
                  scope.row[day].amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }}
              </span>
            </div>
            <div v-else class="secondaryText">--</div>
          </template>
        </el-table-column>
      </el-table>

      <!-- second table -->
      <el-table class="table_no_header" :data="rowData" :show-header="false" style="width: 100%">
        <el-table-column>
          <template slot-scope="scope">
            <div class="small_title">{{ $t('promotion.fundsGrowthPromotion.currentEligibleFund') }}</div>
            <div class="text-base">
              <span class="font-bold">${{ scope.row.currentAccBalance }}</span>
              / <span>5000</span>
              &ensp;
              <i :class="['el-icon-success', { active: currentAccBalanceAchieve }]"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div class="small_title">{{ $t('promotion.fundsGrowthPromotion.weeklySummary.completedTrades') }}</div>
            <div class="text-base">
              <span class="font-bold">{{ scope.row.tradedLots }}</span> / <span>1</span>
              &ensp;
              <i :class="['el-icon-success', { active: tradesAchieved }]"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div class="small_title">
              {{ $t('promotion.fundsGrowthPromotion.weeklySummary.projectedRewardAmount') }}
            </div>
            <div class="text-base text-blueG0 font-bold">${{ scope.row.rewardAmount }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="ltr:text-left rtl:text-right mt-6 mb-4">
      <i18n path="promotion.fundsGrowthPromotion.optInSuccessMsg" tag="span" class="text-grayG4 leading-6">
        <template v-slot:tnc>
          <a :href="tncLink" target="_blank">{{ $t('promotion.fundsGrowthPromotion.tnc') }}</a>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import { startLoading, endLoading } from '@/util/loading';
export default {
  name: 'WeeklyAchivement',
  props: {
    activeAccounts: Array,
    selectedAccount: Number,
    tncLink: String
  },
  data() {
    return {
      days: ['0', '1', '2', '3', '4'],
      rowData: [],

      rewardAmount: 0,
      progressData: [],
      tradedLots: 0,
      tradesAchieved: false,
      isFundOut: true,
      currentAccBalance: 0,
      currentAccBalanceAchieve: false
    };
  },
  mounted() {
    if (this.selectedAccount) this.getDailyProgress();
  },
  watch: {
    selectedAccount() {
      startLoading();
      this.getDailyProgress();
      endLoading();
    }
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 1) {
        return [1, 2];
      }
    },
    getDailyProgress() {
      const selectedAccountInfo = this.activeAccounts.find(acc => acc.mt4Account === this.selectedAccount);
      this.rewardAmount = selectedAccountInfo.totalInterest;
      this.tradesAchieved = selectedAccountInfo.tradesAchieved;
      this.tradedLots = selectedAccountInfo.totalLotsTraded;
      this.currentAccBalance = selectedAccountInfo.fgpAccountInfo?.balance;
      this.currentAccBalanceAchieve = selectedAccountInfo.fgpAccountInfo?.eligible;
      this.progressData = [
        {
          rowTitle: this.$t('promotion.fundsGrowthPromotion.weeklySummary.tableRow.eligbleFunds'),
          ...selectedAccountInfo.weeklyInterest.reduce((acc, { dayOfWeek, balance, balanceEligible }) => {
            acc[dayOfWeek] = { type: 'balance', amount: balance, success: balanceEligible };
            return acc;
          }, {})
        }
      ];
      this.rowData = [
        {
          currentAccBalance: this.currentAccBalance.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),
          tradedLots: this.tradedLots.toFixed(2),
          rewardAmount: this.rewardAmount.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/fundsGrowthPromotion/weeklySummary.scss';
</style>
